import React, { useState } from 'react';
import { Link } from 'react-router-dom';


export default function WhoWeAre() {
  const [openPanel, setOpenPanel] = useState('one');

  const togglePanel = (panelId) => {
    setOpenPanel((prev) => (prev === panelId ? null : panelId));
  };

  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("img/banner/banner-who-we-are.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Who we are</h1>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li>Who we are</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* The Birth of Shamayita Math */}
      <section className="about-style02">
        <div className="container">
          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div
              className="col-md-6 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="image-hover">
                <img
                  src="img/content/w-1.jpeg"
                  alt="The Birth of Shamayita Math"
                  className="border-radius-10"
                />
              </div>
            </div>
            <div className="col-md-6 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <span>The Birth of Shamayita Math</span>
                  <h2 className="mb-0 display-4 font-weight-800 lh-1 ls-minus-2px">
                    The Birth of Shamayita Math: A Dream Turned Reality
                  </h2>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  Shamayita Math is an outcome of the visionary dreams of Sri Sri
                  Prabhuji that came into being on the 15th of August 1996, nearly
                  five decades after the country gained independence. The
                  organization has a focused goal of development of people still
                  untouched in varying degrees by services essential for a decent
                  quality of life.
                </p>
              </div>
            </div>
          </div>

          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div className="col-sm-12 col-lg-12 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  The idea of the organization was conceived during Prabhuji’s
                  time as a yogi in the Himalayas. He envisioned an organization
                  that would have universal love and oneness as the underlying
                  principles.
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  The organization, in his vision, would enable individuals to set
                  foot on the path to liberation, freeing them from
                  fundamentalism, religious dogma, gender inequality, and
                  casteism. The core message of Shamayita Math is that humanity is
                  one, God is one, and religion is one, the differences lie in
                  ignorance. The name "Shamyaita" is derived from Devi Durga and
                  signifies possessing the quality of "Sham," which means having
                  control over the mind.
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  Shamayita Math was founded on August 15, 1996, nearly fifty
                  years after India’s independence, as a realization of Sri Sri
                  Prabhuji’s visionary dreams. The organization is dedicated to
                  uplifting communities that lack access to essential services for
                  a dignified life. Conceived during Prabhuji’s time as a yogi in
                  the Himalayas, Shamayita Math is rooted in the principles of
                  universal love and unity.
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  Prabhuji envisioned an organization that would guide individuals
                  toward liberation by breaking free from fundamentalism, religious
                  dogma, gender inequality, and casteism. At its core, Shamayita
                  Math promotes the belief that humanity, God, and religion are
                  one, with differences arising only from ignorance. The name
                  "Shamayita," inspired by Devi Durga, reflects the quality of
                  "Sham," symbolizing mastery over the mind.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

    {/* Our Inspiration
    ================================================== */}
      <section className="about-style02 pt-1">
        <div className="container">
          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div className="col-md-7 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <span>Our Inspiration</span>
                  <h2 className="mb-3 display-4 font-weight-800 lh-1 ls-minus-2px">
                    A Divine Mission: Breaking Boundaries and Guiding Souls
                  </h2>
                  <h4 className="mb-0 display-17 font-weight-800 lh-1 ls-minus-2px pt-1">
                    The Birth of a Special Soul:
                  </h4>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  The story of Shamayita Math begins when the Divine Soul, Sri Sri
                  Prabhuji, came into this life with a purpose. The Divine Soul has
                  been working unceasingly and silently for a long time to
                  transcend the limitations of society and evolve a new way of
                  living. Unknown to many, the Special Soul is making many
                  transformational improvements for the betterment of numerous
                  people through his yogic powers.
                </p>
              </div>
            </div>
            <div className="col-md-5 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
              <div className="image-hover">
                <img
                  src="img/content/w-2.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
            </div>
          </div>

          <div className="row align-items-lg-center mb-1-9 mt-n1-9 pt-1">
            <div className="col-md-12 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  Long before the birth of the Divine Soul, His loving and devoted
                  parents were made aware that something extraordinary awaited them.
                  They were informed by a divine mystic that their child would not
                  belong to just one family or nation but to the whole world. He was
                  gifted with an innate propensity for self-reflection and
                  contemplation right from His early years.
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  The journey of Shamayita Math began with the arrival of Sri Sri
                  Prabhuji, a Divine Soul born with a profound purpose. For years,
                  Prabhuji has worked tirelessly and quietly to overcome societal
                  limitations and foster a new way of living. Through his yogic
                  powers, this extraordinary soul has silently driven transformative
                  change, uplifting countless lives in ways often unseen.
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  Even before Prabhuji's birth, his devoted parents were foretold by
                  a divine mystic that their child would be no ordinary being. They
                  learned he would belong not to a single family or nation but to
                  the entire world. From a young age, Prabhuji displayed a natural
                  gift for self-reflection and contemplation, setting the foundation
                  for his remarkable mission.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* A Journey of Curiosity and Spiritual Quest */}
      <section className="about-style02 pt-1">
        <div className="container">
          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div className="col-md-8 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h4 className="mb-0 display-17 font-weight-800 lh-1 ls-minus-2px pt-1">
                    A Journey of Curiosity and Spiritual Quest:
                  </h4>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  The childhood of the Holy Soul was unlike others. Not much
                  inclined towards traditional education, He was drawn towards
                  understanding the meaning of life and set out on a spiritual
                  journey, which took him to pilgrimage destinations such as
                  Varanasi and Haridwar in North India. As He traveled through
                  the Himalayas, He hardened his spirit with a strong belief in
                  the Supreme Soul. Despite adversities, He spent time in deep
                  meditation and self-discovery. During this time, He had a
                  life-changing meeting with Barfani Baba (as He was called) and
                  Mataji – the Divine Mother, which He believed, was
                  predestined. The holy touch of the Spiritual Guides turned His
                  youthful quest for life into an indescribable transcendental
                  state.
                </p>
              </div>
            </div>
            <div
              className="col-md-4 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="image-hover">
                <img
                  src="img/content/w-3.jpg"
                  alt="Spiritual Quest"
                  className="border-radius-10"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Creating a Platform for Truth-Seekers
        ================================================== */}
      <section className="about-style02 pt-1">
        <div className="container">
          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div
              className="col-md-4 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="image-hover">
                <img
                  src="img/content/w-6.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
            </div>
            <div className="col-md-8 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h4 className="mb-0 display-17 font-weight-800 lh-1 ls-minus-2px pt-1">
                    Creating a Platform for Truth-Seekers:
                  </h4>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  In 1967, after mastering spiritual practices and gaining
                  clarity of his life's purpose, Sri Sri Prabhuji, the Divine
                  Soul, returned home. He envisioned creating a global platform
                  for truth-seekers to explore the Supreme Truth and the unity
                  of individual souls (Jivatma) with the Supreme Soul
                  (Parmatama).
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  For 15 years, Prabhuji lived in seclusion in a simple thatched
                  cottage on the outskirts of Ranbahal village in West Bengal's
                  Bankura district, frequently entering a superconscious state
                  of unity with the Absolute Spirit. During this time, he
                  developed a vision to alleviate human suffering and uplift
                  those in hardship. This inspired him to establish the
                  "Abatanik Vidyadan Kendra" in 1975, a center dedicated to
                  educating underprivileged rural children. Supported by devoted
                  volunteer teachers, this initiative laid the foundation for
                  Shamayita Math.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Shamayita Math: Expanding Services to Society
        ================================================== */}
      <section className="about-style02 pt-1">
        <div className="container">
          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div className="col-md-8 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h4 className="mb-0 display-17 font-weight-800 lh-1 ls-minus-2px pt-1">
                    Shamayita Math: Expanding Services to Society:
                  </h4>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  The vision of Sri Sri Prabhuji, the Divine Soul, to uplift
                  humanity took shape with the formal establishment of Shamayita
                  Math on August 15, 1996. Since its inception, the organization
                  has grown steadily, expanding its efforts to serve society
                  through initiatives in health, education, skill development,
                  livelihoods, inclusion of differently-abled individuals, and
                  more. At the core of all its endeavors lies the guiding
                  principle of self-realization. Prabhuji firmly believes that
                  true positive impact on others begins with a deep
                  understanding of oneself.
                </p>
              </div>
            </div>
            <div
              className="col-md-4 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="image-hover">
                <img
                  src="img/content/w-7.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

        {/* Guiding Souls Towards Liberation and Eternal Happiness
        ================================================== */}
      <section className="about-style02 pt-1">
        <div className="container">
          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div
              className="col-md-4 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="image-hover">
                <img
                  src="img/content/w-9.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
            </div>
            <div className="col-md-8 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h4 className="mb-0 display-17 font-weight-800 lh-1 ls-minus-2px pt-1">
                    Guiding Souls Towards Liberation and Eternal Happiness:
                  </h4>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  Today, a humble dwelling is home to the Divine Soul, where He
                  stays committed to the divine mission. The place is known as
                  Vedanta Kutir, which reflects a rare blend of the ancient
                  lifestyle of a yogi and a contemporary approach to
                  spirituality. Revered Prabhuji has been residing here since
                  His Paribrajak (spiritual travels). He provides constant
                  guidance to His followers, leading them towards the liberation
                  of human souls and eternity, helping them break away from the
                  illusions of the material world (Maya).
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  During Prabhuji's travel to the Himalayas, He met a Sage with
                  whom He spent a few days, exchanging spiritual thoughts. At
                  the time of parting, He was gifted a Jyotirlingam made of
                  black stone by the Himalayan Sage, who christened it
                  "Kedareswar Shiva". On His return to Ranbahal, the
                  Jyotirlingam was kept in His dwelling. At the time of
                  Prabhuji's birth, His parents had an auspicious sight of
                  hundreds of Jyotirlingams and realized His divine connection
                  with Lord Shiva. On 14 March 1967, a temple was opened where
                  the Jyotirlingam was placed and named Kedareswar Temple, which
                  is just beside the Vedanta Kutir. Since then, each day at
                  Shamayita Math begins with the worship of Kedareswar Shiva
                  followed by the morning Aarti.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Philosophy */}
      <section className="about-style02 pt-1">
        <div className="container">
          <div className="row align-items-lg-center mb-1-9 mt-n1-9">
            <div className="col-md-8 mt-1-9">
              <div className="pe-lg-10 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <span>Our Philosophy</span>
                  <h2 className="mb-3 display-4 font-weight-800 lh-1 ls-minus-2px">
                    Our Philosophy: Self-Realization and Empowerment
                  </h2>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  The core philosophy of Shamayita Math is that the ultimate
                  goal of life is self-realization. We are of the belief that a
                  person does not have to go through extreme penance or follow
                  strict customs and doctrines to achieve self-knowledge. One
                  can do so by going deep into one’s inner self and learning the
                  larger meaning of ‘I’. As Prabhuji says, the smaller ego must
                  be sacrificed within the huge realm of consciousness.
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  We implement different developmental activities for society to
                  bring about a conscious awareness of the self in day-to-day
                  life. We view service or karma as a means that enables one to
                  rise above the limited sense of self and live with an expanded
                  soul. As Prabhuji puts it, service is not mercy, sympathy,
                  favor, or even a political fad rather it is the profound love
                  acquired by a seeker (sadhaka) through the spiritual practice
                  (sadhana).
                </p>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  We believe that a supreme, divine, and eternal power governs
                  this world. One tends to lose touch with the inner self due to
                  our constant focus on the external world. Our goal is to make
                  people aware of their inherent power and unlimited potential
                  by helping them to redirect their attention inward, wherein
                  lies the true happiness. The moment we discover the “Greater
                  I” within ourselves, it motivates us to work for the
                  betterment of humanity.
                </p>
              </div>
            </div>
            <div
              className="col-md-4 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div className="image-hover">
                <img
                  src="/img/content/w-10.jpg"
                  alt="..."
                  className="border-radius-10"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="bg-img parallax map-h500"
        style={{ backgroundImage: 'url("img/bg/bg-02.jpg")' }}
      ></section>

      {/* TESTIMONIALS ================================================== */}
      <section className="bg-secondary">
        <div className="container">
          <div className="section-title01 mb-1-9 mb-lg-8 text-center">
            <span>Our Team</span>
            <h2 className="mb-0 display-4 font-weight-800 lh-1 text-white w-lg-70 w-xl-60 w-xxl-50 mx-auto ls-minus-2px">
              United in the Cause of Humanity
            </h2>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row justify-content-center mt-n1-9">
            {/* Left Column */}
            <div className="col-lg-6 col-xxl-5 mt-1-9">
              <div
                className="section-title01 mb-1-9 mb-lg-2-9 wow fadeInUp"
                data-wow-delay="100ms"
              >
                <span>Our Team</span>
                <h2 className="mb-0 display-4 font-weight-800 lh-1 ls-minus-2px">
                  United in the Cause of Humanity
                </h2>
              </div>
              <p className="wow fadeInUp" data-wow-delay="150ms">
                Shamayita Math believes in cultivating inclusivity and an
                environment that embraces all. Guided by the divine philosophy
                of Prabhuji, we work as a Parivaar (family), where sannyasins,
                dedicated brothers, volunteers, professionals from varied
                fields, technical personnel, community resource persons, and
                support staff work in tandem for the upliftment of humanity.
              </p>
              <p className="wow fadeInUp" data-wow-delay="150ms">
                At present, we operate separate units in Bankura, Jhargram, Paschim Barddhaman and Paschim Medinipore in West Bengal, East Singbhum and West Singbhum in Jharkhand and Dantewada in Chhattisgarh. Each unit has a team leader, project executives, technical experts, and community mobilizers, who work diligently to execute the various activities in their area. Through the localized approach, each unit effectively addresses the unique needs and challenges of each community that it works with.
              </p>
              <p className="wow fadeInUp" data-wow-delay="150ms">
                To bring in further effectiveness, growth, and strategic
                direction, Shamayita Math has formed an advisory board
                comprising eminent academicians, agriculturists, scientists,
                experts in natural resource management, finance specialists, and
                administrative personnel for constant guidance.
              </p>
            </div>

            {/* Right Accordion */}
            <div className="col-lg-6 col-xl-5 offset-xl-1 offset-xxl-2 mt-1-9">
              <div className="accordion-style style02" id="accordion1">
                {/* Accordion 1 */}
                <div className="card mb-3 wow fadeInUp" data-wow-delay="100ms">
                  <div className="card-header" id="headingOne1">
                    <h5 className="mb-0">
                      <button
                        className={`btn btn-link ${
                          openPanel === "one" ? "" : "collapsed"
                        }`}
                        onClick={() => togglePanel("one")}
                      >
                        Our Team as Inclusive Parivaar
                      </button>
                    </h5>
                  </div>
                  {openPanel === "one" && (
                    <div
                      className="collapse show"
                      aria-labelledby="headingOne1"
                    >
                      <div className="card-body">
                        <p className="text-white opacity6">
                          Rooted in Sri Sri Prabhuji’s divine philosophy,
                          Shamayita Math operates as a Parivaar (family),
                          bringing together sannyasins, dedicated brothers,
                          volunteers, professionals from diverse fields,
                          technical staff, community resource persons, and
                          support personnel to work collectively for the
                          upliftment of humanity.
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Accordion 2 */}
                <div className="card mb-3 wow fadeInUp" data-wow-delay="150ms">
                  <div className="card-header" id="headingTwo1">
                    <h5 className="mb-0">
                      <button
                        className={`btn btn-link ${
                          openPanel === "two" ? "" : "collapsed"
                        }`}
                        onClick={() => togglePanel("two")}
                      >
                        Operational Units
                      </button>
                    </h5>
                  </div>
                  {openPanel === "two" && (
                    <div
                      className="collapse show"
                      aria-labelledby="headingTwo1"
                    >
                      <div className="card-body">
                        <p className="text-white opacity6">
                          Shamayita Math manages dedicated units in West Bengal
                          (Bankura, Salboni, Jhargram, and Durgapur) and
                          Chhattisgarh (Sonadih and Kirandul). Each unit is led
                          by a team leader, supported by project executives,
                          technical experts, and community mobilizers, who
                          tailor initiatives to meet the unique needs and
                          challenges of their respective communities.
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {/* Accordion 3 */}
                <div className="card wow fadeInUp" data-wow-delay="200ms">
                  <div className="card-header" id="headingThree1">
                    <h5 className="mb-0">
                      <button
                        className={`btn btn-link ${
                          openPanel === "three" ? "" : "collapsed"
                        }`}
                        onClick={() => togglePanel("three")}
                      >
                        Advisory Board
                      </button>
                    </h5>
                  </div>
                  {openPanel === "three" && (
                    <div
                      className="collapse show"
                      aria-labelledby="headingThree1"
                    >
                      <div className="card-body">
                        <p className="text-white opacity6">
                          To ensure strategic growth and impactful outcomes,
                          Shamayita Math is guided by an advisory board
                          comprising esteemed academicians, agriculturists,
                          scientists, natural resource management experts,
                          finance specialists, and administrative professionals,
                          providing continuous direction to our efforts.
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};


